import * as React from "react";
import { Button, Row, Col } from "reactstrap";

export class Option<T> {
    private title: string;
    private value: T;

    constructor(title: string, value: T) {
        this.title = title;
        this.value = value;
    }

    public getTitle(): string {
        return this.title;
    }

    public getValue(): T {
        return this.value;
    }
}

export interface SelectOneProps<T> {
    title: string;
    id: string;
    paragraph: string;
    options: Option<T>[];
    currentOption?: Option<T>;
    optionChosen: (option: Option<T>) => void;
}

interface State<T> {
    currentOption?: Option<T>;
}

export class SelectOne<T> extends React.Component<SelectOneProps<T>, State<T>>
{
    constructor(props: SelectOneProps<T>) {
        super(props);
        this.state = {
            currentOption: props.currentOption
        }
    }

    componentDidUpdate(prevProps: SelectOneProps<T>) {
        if (this.props.currentOption != prevProps.currentOption) {
            this.setState(
                {
                    currentOption: this.props.currentOption
                });
        }
    }

    createChoices() {
        let choices = [];

        for (let i = 0; i < this.props.options.length; i++) {
            let option = this.props.options[i];
            let classes = "choice";
            if (this.state.currentOption == option) {
                classes += " selected";
            }
            choices.push(
                <Col key={i} className="col-6 col-sm-4 col-md-4 py-2 px-2">
                    <Button key={i} className={classes} id={ option.getTitle().replace(" ","") + this.props.id} onClick={() => this.props.optionChosen(option)}>
                        {option.getTitle()}
                    </Button>
                </Col>
            );
        }
        return choices;
      }

  render() {
    return (
      <div>
            {this.props.title.length > 1 &&
            
                <Row>
                    <Col className="text-center">
                        <h3 className="text-uppercase">{this.props.title}</h3>
                    </Col>
                </Row>
            }
            {this.props.paragraph.length > 1 && 
                <Row>
                    <Col className="text-center">
                        <p>{this.props.paragraph}</p>
                    </Col>
                </Row>
}
        <Row className="justify-content-center">{this.createChoices()}</Row>
      </div>
    );
  }
}
